import classNames from 'classnames';
import NotificationAlertType from '../../../../types/NotificationAlert';
import testIds from './testIds';
import Link from '../../common/Link/Link';
import ExclamationCircle from '../../common/Icons/ExclamationCircle';
import tailwindConfig from '../../../../tailwind.config';

type Props = {
  message: NotificationAlertType['message'];
  url: NotificationAlertType['url'];
};

const NotificationAlert = ({ message, url }: Props) => {
  return (
    <div
      className={classNames('bg-yellow-700 text-sm font-medium text-yellow-50', {
        underline: !!url,
      })}
      role="alert"
      data-nosnippet
      data-testid={testIds.message}
    >
      <div className="mx-auto min-h-6 max-w-screen-xl px-4 py-1 text-center sm:px-8">
        <div className="mr-1 inline-flex align-text-bottom">
          <ExclamationCircle size={16} color={tailwindConfig.theme.colors.yellow[50]} />
        </div>
        {url ? (
          <Link href={url} passHref prefetch={false}>
            <a target="_blank" rel="noreferrer" className="text-yellow-50">
              {message}
            </a>
          </Link>
        ) : (
          message
        )}
      </div>
    </div>
  );
};

export default NotificationAlert;
